__webpack_require__.p = "/02Challenges_Interactive_rating_component/";